import {
	Notifications,
	NotificationsActive
} from "@mui/icons-material"
import { instance } from "../Components/config";
import {
	Button,
	ClickAwayListener,
	IconButton,
	List,
	ListItem,
	ListItemText,
	Typography as MuiTypography,
	Popper,
	Paper,
	Badge,
	Grow,
} from "@mui/material"
import { useAuth } from "../Components/AuthContext"
import { DialogAlert } from "./DialogAlert";

import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";


function AppBarNotification() {
	const { user } = useAuth();
	const [open, setOpen] = React.useState(false);
	const anchorRef = React.useRef(null);
	const navigate = useNavigate();
	const [notifications, setNotifications] = React.useState([])
	const [loading, setLoading] = useState(true);
	const unreadCount = notifications.filter(notification => !notification.visto).length;//notifications.find((item) => !item.visto);
	const [openDialog, setOpenDialog] = useState(false);
	const [dialog, setDialog] = useState({
		title: "",
		text: "",
	});

	useEffect(() => {
		if(user?.id){
			instance
			.get(`/notificacion/listByUser?id=${user.id}&limit=10`)
			.then((res) => {
				setNotifications(res.data)
				setLoading(false);
			})
			.catch((err) => {
				if (err.response.status === 500) {
					setDialog({
						title: "Error",
						text: "Existe algún problema con el servidor, por favor inténtalo de nuevo mas tarde, si el problema persiste contáctate con alguno de los encargados.",
					});
					setOpenDialog(true);
				}
				setLoading(false);
			})
			.finally();
		}
		
	}, [])

	const handleToggle = () => {
		setOpen((prevOpen) => !prevOpen);
	}

	const handleClose = (event) => {
		if (anchorRef.current && anchorRef.current.contains(event.target)) {
			return;
		}
		setOpen(false);
		// actualizar las notificaciones guardadas
	}

	const handleCambiarEstado = (index) => {
		setNotifications(notifications.map((notification, i) =>
			i === index ? { ...notification, visto: true } : notification
		));
		// update en bd
		instance.post('/notificacion/update', {
			id: user.id,
			notificacion: notifications[index].Id
		})
		.then()
		.catch()
		.finally();
	};

	const handleViewAllNotifications = () => {
		setOpen(false);
		navigate("/notificaciones");
	}

	return (
		<>
			<IconButton
				size="large"
				aria-controls={open ? "notification-menu" : undefined}
				aria-expanded={open ? "true" : undefined}
				onClick={handleToggle}
				ref={anchorRef}
			>
				<Badge badgeContent={unreadCount} color="error">
					{unreadCount > 0 ? <NotificationsActive color="action" /> : <Notifications color="action" />}
				</Badge>
			</IconButton>
			<Popper
				open={open}
				anchorEl={anchorRef.current}
				role={undefined}
				transition
				disablePortal
				style={{ zIndex: 1 }}
				placement="bottom-end"
			>
				{({ TransitionProps }) => (
					<Grow
						{...TransitionProps}
						style={{ transformOrigin: "center top" }}
					>
						<Paper style={{ maxHeight: 300, maxWidth:350, overflow: 'auto', boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)' }}>
							<ClickAwayListener onClickAway={handleClose}>
								<List>
									<ListItem>
										<Button fullWidth size="small" onClick={handleViewAllNotifications}>
											Ver todas las notificaciones
										</Button>
									</ListItem>
									{loading ? (
										<ListItem>
											<ListItemText primary="Cargando notificaciones..." />
										</ListItem>
									) : (
										notifications.slice(0, 10).map((notification, index) => (
											<ListItem
												key={index}
												onClick={() => handleCambiarEstado(index)}
												style={{ backgroundColor: notification.visto ? 'inherit' : '#f0f0f0' }}
											>
												<ListItemText
													primary={notification.titulo}
													secondary={
														<>
															<MuiTypography component="span" variant="body2" color="textPrimary">
																{notification.mensaje}
															</MuiTypography>
															{" - " + new Date(notification.fechaHora).toLocaleDateString("en-GB", { hour: "numeric", hour12: false, minute: "numeric" })}
														</>
													}
												/>
											</ListItem>
										))
									)}
								</List>
							</ClickAwayListener>
						</Paper>
					</Grow>
				)}
			</Popper>
			<DialogAlert
          title={dialog.title}
          text={dialog.text}
          open={openDialog}
          setOpen={setOpenDialog}
          redirectOnClose={dialog.redirect}
          page={dialog.page}
          pageState={dialog.pageState}
        />
		</>
	);
}

export { AppBarNotification };